export default "__VITE_ASSET__c8c53b55__"